import {Component, Input} from '@angular/core';
import {Params, RouterLink} from "@angular/router";
import {NgClass, NgTemplateOutlet} from "@angular/common";

import {NgbCollapse} from "@ng-bootstrap/ng-bootstrap";

export interface SidebarMenuItem {
  id: number;
  title: string;
  badge?: number;
  routerLink: any[];
  queryParams?: Params;
  iconClass?: string;
}

@Component({
    selector: 'nz-sidebar-menu',
    imports: [
        NgTemplateOutlet,
        RouterLink,
        NgbCollapse,
        NgClass
    ],
    templateUrl: './sidebar-menu.component.html',
    styleUrl: './sidebar-menu.component.scss'
})
export class SidebarMenuComponent {
  @Input() title: string = '';
  @Input() items: SidebarMenuItem[] = [];
  @Input() selectedItem?: SidebarMenuItem;
  @Input() queryParamsHandling: 'merge' | 'preserve' | 'replace' | '' = 'merge';

  protected isMenuCollapsed: boolean = true;
}
